import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export default function ForgotPasswordPage() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await resetPassword(email);
    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      setSent(true);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--brand-paper)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-xxl)', fontFamily: 'var(--font-ui)' }}>
      <div style={{ width: '100%', maxWidth: 400 }}>

        <div style={{ textAlign: 'center', marginBottom: 'var(--space-h3)' }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <span style={{ fontSize: 36 }}>📖</span>
            <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--font-size-h3)', fontWeight: 700, color: 'var(--neutral-800)', margin: '8px 0 4px' }}>Reanlo</h1>
          </Link>
        </div>

        <div style={{ background: 'var(--brand-white)', borderRadius: 'var(--radius-xxl)', padding: 'var(--space-h3)', border: '1px solid var(--brand-sand)', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
          {sent ? (
            /* Success state */
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <span style={{ fontSize: 'var(--font-size-hero)', display: 'block', marginBottom: 'var(--space-lg)' }}>📬</span>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 700, color: 'var(--neutral-800)', margin: '0 0 8px' }}>Check your inbox</h2>
              <p style={{ fontSize: 'var(--font-size-md)', color: 'var(--neutral-500)', margin: '0 0 24px', lineHeight: 1.6 }}>
                We sent a password reset link to <strong style={{ color: 'var(--neutral-800)' }}>{email}</strong>. It expires in 24 hours.
              </p>
              <Link to="/login" style={{ fontSize: 'var(--font-size-base)', color: 'var(--feedback-warning)', fontWeight: 600, textDecoration: 'none' }}>
                ← Back to log in
              </Link>
            </div>
          ) : (
            <>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 700, color: 'var(--neutral-800)', margin: '0 0 6px' }}>Reset your password</h2>
              <p style={{ fontSize: 'var(--font-size-base)', color: 'var(--neutral-500)', margin: '0 0 24px' }}>We'll send you a link to reset it.</p>

              {error && (
                <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 'var(--radius-10)', padding: '10px 14px', marginBottom: 'var(--space-xl)' }}>
                  <p style={{ fontSize: 'var(--font-size-base)', color: 'var(--feedback-error)', margin: 'var(--space-none)' }}>{error}</p>
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 'var(--space-xxl)' }}>
                  <label style={{ fontSize: 'var(--font-size-base)', fontWeight: 600, color: 'var(--neutral-800)', display: 'block', marginBottom: 'var(--space-6)' }}>Email address</label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    required
                    style={{ width: '100%', padding: '11px 14px', borderRadius: 'var(--radius-10)', border: '1px solid var(--brand-sand)', fontSize: 'var(--font-size-md)', color: 'var(--neutral-800)', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', background: 'var(--brand-paper)' }}
                    onFocus={e => e.target.style.borderColor = '#d97706'}
                    onBlur={e => e.target.style.borderColor = '#e8e4dc'}
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  style={{ width: '100%', padding: '13px', borderRadius: 'var(--radius-10)', border: 'none', background: loading ? 'var(--neutral-400)' : 'var(--neutral-800)', color: 'var(--brand-paper)', fontSize: 'var(--font-size-md)', fontWeight: 700, cursor: loading ? 'default' : 'pointer' }}
                >
                  {loading ? 'Sending...' : 'Send reset link'}
                </button>
              </form>

              <div style={{ textAlign: 'center', marginTop: 'var(--space-xl)' }}>
                <Link to="/login" style={{ fontSize: 'var(--font-size-base)', color: 'var(--neutral-500)', textDecoration: 'none' }}>
                  ← Back to log in
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
